(function() {
  const SERVER_URL = 'https://kiage-bot-production.up.railway.app';

  let SESSION_ID = localStorage.getItem('kiage_session_id');
  if (!SESSION_ID) {
    SESSION_ID = 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    localStorage.setItem('kiage_session_id', SESSION_ID);
  }

  let chatVerlauf = JSON.parse(localStorage.getItem('kiage_chat_verlauf') || '[]');
  let pollingInterval = null;
  let chatOpen = false;
  let selectedFiles = [];

  const style = document.createElement('style');
  style.textContent = `
    #kiage-chat-btn { position: fixed; bottom: 24px; right: 24px; width: 60px; height: 60px; border-radius: 50%; background: #1a1a1a; color: white; border: none; cursor: pointer; box-shadow: 0 4px 20px rgba(0,0,0,0.3); font-size: 28px; z-index: 9999; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; }
    #kiage-chat-btn:hover { transform: scale(1.1); }
    #kiage-chat-badge { position: absolute; top: -4px; right: -4px; background: #e74c3c; color: white; border-radius: 50%; width: 20px; height: 20px; font-size: 12px; display: none; align-items: center; justify-content: center; }
    #kiage-chat-window { position: fixed; bottom: 96px; right: 24px; width: 380px; height: 580px; background: white; border-radius: 16px; box-shadow: 0 8px 40px rgba(0,0,0,0.2); display: none; flex-direction: column; z-index: 9998; overflow: hidden; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
    #kiage-chat-header { background: #1a1a1a; color: white; padding: 16px 20px; display: flex; align-items: center; gap: 12px; }
    #kiage-chat-header-avatar { width: 40px; height: 40px; border-radius: 50%; background: #c9a96e; display: flex; align-items: center; justify-content: center; font-size: 20px; }
    #kiage-chat-header-info h4 { margin: 0; font-size: 15px; font-weight: 600; }
    #kiage-chat-header-info p { margin: 0; font-size: 12px; opacity: 0.7; }
    #kiage-chat-neu { background: none; border: 1px solid rgba(255,255,255,0.4); color: white; font-size: 11px; cursor: pointer; padding: 4px 10px; border-radius: 12px; margin-left: auto; font-family: inherit; }
    #kiage-chat-neu:hover { background: rgba(255,255,255,0.1); }
    #kiage-chat-close { background: none; border: none; color: white; font-size: 22px; cursor: pointer; opacity: 0.7; margin-left: 8px; }
    #kiage-chat-messages { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 12px; background: #f8f8f6; }
    .kiage-msg { max-width: 85%; padding: 10px 14px; border-radius: 12px; font-size: 14px; line-height: 1.5; word-wrap: break-word; }
    .kiage-msg-bot { background: white; color: #1a1a1a; border-bottom-left-radius: 4px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); align-self: flex-start; }
    .kiage-msg-user { background: #1a1a1a; color: white; border-bottom-right-radius: 4px; align-self: flex-end; }
    .kiage-typing { display: flex; gap: 4px; padding: 12px 16px; background: white; border-radius: 12px; border-bottom-left-radius: 4px; align-self: flex-start; width: fit-content; }
    .kiage-typing span { width: 8px; height: 8px; background: #ccc; border-radius: 50%; animation: kiage-bounce 1.2s infinite; }
    .kiage-typing span:nth-child(2) { animation-delay: 0.2s; }
    .kiage-typing span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes kiage-bounce { 0%, 60%, 100% { transform: translateY(0); } 30% { transform: translateY(-6px); } }
    .kiage-buttons { display: flex; flex-wrap: wrap; gap: 8px; align-self: flex-start; max-width: 100%; }
    .kiage-product-btn {
      display: inline-block;
      background: #1E4A2E;
      color: white !important;
      padding: 10px 20px;
      border-radius: 100px;
      text-decoration: none !important;
      font-size: 14px;
      font-weight: 700;
      margin: 8px 0;
      transition: background 0.2s;
    }
    .kiage-product-btn:hover { background: #2a6340; }
    .kiage-btn-option { background: white; border: 2px solid #1a1a1a; border-radius: 20px; padding: 8px 16px; font-size: 13px; cursor: pointer; color: #1a1a1a; font-family: inherit; transition: all 0.2s; }
    .kiage-btn-option:hover { background: #1a1a1a; color: white; }
    .kiage-btn-option:disabled { opacity: 0.4; cursor: not-allowed; }
    .kiage-label-btn { display: inline-block; margin-top: 10px; background: #1a1a1a; color: white; padding: 12px 20px; border-radius: 24px; text-decoration: none; font-size: 14px; font-weight: 600; cursor: pointer; }
    .kiage-label-btn:hover { background: #333; }
    .kiage-tracking-btn { display: inline-block; margin-top: 10px; background: #c9a96e; color: white; padding: 12px 20px; border-radius: 24px; text-decoration: none; font-size: 14px; font-weight: 600; cursor: pointer; }
    .kiage-tracking-btn:hover { background: #b8955a; }
    #kiage-chat-input-area { padding: 12px 16px; padding-bottom: 24px; background: white; border-top: 1px solid #eee; display: flex; flex-direction: column; gap: 8px; }
    #kiage-chat-input-row { display: flex; gap: 8px; align-items: flex-end; }
    #kiage-chat-input { flex: 1; border: 1px solid #e0e0e0; border-radius: 20px; padding: 10px 16px; font-size: 14px; outline: none; resize: none; font-family: inherit; max-height: 80px; }
    #kiage-chat-send { width: 40px; height: 40px; border-radius: 50%; background: #1a1a1a; color: white; border: none; cursor: pointer; font-size: 18px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    #kiage-chat-send:hover { background: #333; }
    #kiage-foto-btn { background: none; border: 1px solid #e0e0e0; border-radius: 20px; padding: 6px 14px; font-size: 12px; cursor: pointer; color: #666; display: flex; align-items: center; gap: 6px; width: fit-content; font-family: inherit; }
    #kiage-foto-btn:hover { border-color: #1a1a1a; color: #1a1a1a; }
    #kiage-foto-preview { display: flex; gap: 6px; flex-wrap: wrap; }
    .kiage-foto-thumb { width: 48px; height: 48px; border-radius: 8px; object-fit: cover; border: 2px solid #e0e0e0; }
    @media (max-width: 480px) { #kiage-chat-window { width: 100vw; height: 100vh; bottom: 0; right: 0; border-radius: 0; } }
  `;
  document.head.appendChild(style);

  const html = '<button id="kiage-chat-btn" title="Chat mit uns">💬<div id="kiage-chat-badge">1</div></button><div id="kiage-chat-window"><div id="kiage-chat-header"><div id="kiage-chat-header-avatar">✨</div><div id="kiage-chat-header-info"><h4>Kiage Kundenberater</h4><p>Normalerweise antworte ich sofort</p></div><button id="kiage-chat-neu">Neuer Chat</button><button id="kiage-chat-close">×</button></div><div id="kiage-chat-messages"></div><div id="kiage-chat-input-area"><div id="kiage-foto-preview"></div><div id="kiage-chat-input-row"><textarea id="kiage-chat-input" placeholder="Nachricht schreiben..." rows="1"></textarea><button id="kiage-chat-send">➤</button></div><input type="file" id="kiage-foto-input" accept="image/*" multiple style="display:none"><button id="kiage-foto-btn">📷 Foto hinzufügen</button></div></div>';

  const container = document.createElement('div');
  container.innerHTML = html;
  document.body.appendChild(container);

  const btn = document.getElementById('kiage-chat-btn');
  const window_ = document.getElementById('kiage-chat-window');
  const messages = document.getElementById('kiage-chat-messages');
  const input = document.getElementById('kiage-chat-input');
  const send = document.getElementById('kiage-chat-send');
  const fotoBtn = document.getElementById('kiage-foto-btn');
  const fotoInput = document.getElementById('kiage-foto-input');
  const fotoPreview = document.getElementById('kiage-foto-preview');
  const badge = document.getElementById('kiage-chat-badge');

  function speichereVerlauf() {
    localStorage.setItem('kiage_chat_verlauf', JSON.stringify(chatVerlauf));
  }

  function formatText(text) {
    text = text.replace(/(https:\/\/www\.kiage\.de\/products\/[^\s<\n]+)/g, function(url) {
      return '<br><a href="' + url + '" target="_blank" class="kiage-product-btn">🎯 Zum Duft →</a>';
    });
    return text.replace(/\n/g, '<br>').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }

  function zeigeNachricht(text, typ, speichern) {
    if (speichern === undefined) speichern = true;
    const msg = document.createElement('div');
    msg.className = 'kiage-msg kiage-msg-' + typ;

    if (text.indexOf('LABEL_DOWNLOAD:') !== -1) {
      const parts = text.split('LABEL_DOWNLOAD:');
      const vorher = parts[0].trim();
      const rest = parts[1].trim().split('\n');
      const url = rest[0].trim();
      const nachher = rest.slice(1).join('\n').trim();
      let html = '';
      if (vorher) html += formatText(vorher) + '<br>';
      html += '<a href="' + url + '" target="_blank" class="kiage-label-btn">📄 Retourenlabel herunterladen</a>';
      if (nachher) html += '<br><br>' + formatText(nachher);
      msg.innerHTML = html;
    } else if (text.indexOf('tracking.dpd') !== -1) {
      const urlMatch = text.match(/(https?:\/\/[^\s<\n]+)/);
      const url = urlMatch ? urlMatch[1] : null;
      const ohneUrl = url ? text.replace(url, '').replace(/\n+$/, '').trim() : text;
      let html = formatText(ohneUrl);
      if (url) html += '<br><a href="' + url + '" target="_blank" class="kiage-tracking-btn">🚚 Paket verfolgen</a>';
      msg.innerHTML = html;
    } else {
      msg.innerHTML = formatText(text);
    }

    messages.appendChild(msg);
    messages.scrollTop = messages.scrollHeight;
    if (speichern) {
      chatVerlauf.push({ text: text, typ: typ });
      speichereVerlauf();
    }
    return msg;
  }

  function ladeVerlauf() {
    chatVerlauf.forEach(function(m) { zeigeNachricht(m.text, m.typ, false); });
  }

  function zeigeButtons(optionen, onKlick) {
    const wrapper = document.createElement('div');
    wrapper.className = 'kiage-buttons';
    optionen.forEach(function(opt) {
      const b = document.createElement('button');
      b.className = 'kiage-btn-option';
      b.textContent = opt;
      b.addEventListener('click', function() {
        wrapper.querySelectorAll('button').forEach(function(bb) { bb.disabled = true; });
        zeigeNachricht(opt, 'user');
        onKlick(opt);
      });
      wrapper.appendChild(b);
    });
    messages.appendChild(wrapper);
    messages.scrollTop = messages.scrollHeight;
  }

  function zeigeTyping() {
    const t = document.createElement('div');
    t.className = 'kiage-typing'; t.id = 'kiage-typing';
    t.innerHTML = '<span></span><span></span><span></span>';
    messages.appendChild(t);
    messages.scrollTop = messages.scrollHeight;
  }

  function entferneTyping() {
    const t = document.getElementById('kiage-typing');
    if (t) t.remove();
  }

  async function sendeAnServer(text, mitFotos) {
    zeigeTyping();
    try {
      const formData = new FormData();
      formData.append('sessionId', SESSION_ID);
      formData.append('nachricht', text);
      if (mitFotos) {
        selectedFiles.forEach(function(file) { formData.append('fotos', file); });
        selectedFiles = [];
        fotoPreview.innerHTML = '';
      }
      const response = await fetch(SERVER_URL + '/chat', { method: 'POST', body: formData });
      const data = await response.json();
      entferneTyping();
      if (data.antwort) zeigeNachricht(data.antwort, 'bot');
      if (data.zeigeGrundButtons) {
        zeigeButtons(['😕 Duft gefällt mir nicht', '📦 Falscher Duft geliefert', '💔 Beschädigter Duft', '✍️ Anderer Grund'], function(grund) {
          sendeAnServer(grund, false);
        });
      }
      if (data.handoff) startPolling();
      return data;
    } catch (e) {
      entferneTyping();
      zeigeNachricht('Verbindungsfehler. Bitte erneut versuchen.', 'bot');
    }
  }

  function zeigeBegruessing() {
    zeigeNachricht('Hallo! 👋 Willkommen bei Kiage Fragrances!\n\nWie kann ich dir heute helfen?', 'bot');
    zeigeButtons(['🌸 Duftberatung', '📦 Bestellstatus', '🔄 Retoure & Tausch'], function(auswahl) {
      if (auswahl.indexOf('Duftberatung') !== -1) { sendeAnServer('Ich moechte eine Duftberatung'); }
      else if (auswahl.indexOf('Bestellstatus') !== -1) { sendeAnServer('Ich moechte meinen Bestellstatus abfragen'); }
      else if (auswahl.indexOf('Retoure') !== -1) { sendeAnServer('Ich moechte eine Retoure'); }
    });
  }

  function neuerChat() {
    if (!confirm('Moechtest du einen neuen Chat starten?')) return;
    localStorage.removeItem('kiage_session_id');
    localStorage.removeItem('kiage_chat_verlauf');
    chatVerlauf = [];
    SESSION_ID = 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    localStorage.setItem('kiage_session_id', SESSION_ID);
    messages.innerHTML = '';
    zeigeBegruessing();
  }

  async function sendeNachricht() {
    const text = input.value.trim();
    if (!text && selectedFiles.length === 0) return;
    if (text) { zeigeNachricht(text, 'user'); input.value = ''; }
    if (selectedFiles.length > 0) { zeigeNachricht('📸 ' + selectedFiles.length + ' Foto(s) gesendet', 'user'); }
    await sendeAnServer(text || 'Hier sind meine Fotos', selectedFiles.length > 0);
  }

  function startPolling() {
    if (pollingInterval) return;
    pollingInterval = setInterval(async function() {
      try {
        const response = await fetch(SERVER_URL + '/chat/update/' + SESSION_ID);
        const data = await response.json();
        if (data.neu && data.antwort) {
          zeigeNachricht(data.antwort, 'bot');
          if (!chatOpen) badge.style.display = 'flex';
        }
      } catch (e) {}
    }, 3000);
  }

  btn.addEventListener('click', function() {
    chatOpen = !chatOpen;
    window_.style.display = chatOpen ? 'flex' : 'none';
    badge.style.display = 'none';
    btn.style.display = chatOpen ? 'none' : 'flex';
    if (chatOpen && messages.children.length === 0) {
      if (chatVerlauf.length > 0) { ladeVerlauf(); } else { zeigeBegruessing(); }
    }
  });

  document.getElementById('kiage-chat-close').addEventListener('click', function() {
    chatOpen = false;
    window_.style.display = 'none';
    btn.style.display = 'flex';
  });

  document.getElementById('kiage-chat-close').addEventListener('click', function() { chatOpen = false; window_.style.display = 'none'; });
  document.getElementById('kiage-chat-neu').addEventListener('click', neuerChat);
  send.addEventListener('click', sendeNachricht);
  input.addEventListener('keydown', function(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendeNachricht(); } });
  fotoBtn.addEventListener('click', function() { fotoInput.click(); });
  fotoInput.addEventListener('change', function(e) {
    selectedFiles = Array.from(e.target.files);
    fotoPreview.innerHTML = '';
    selectedFiles.forEach(function(file) {
      const reader = new FileReader();
      reader.onload = function(ev) {
        const img = document.createElement('img');
        img.src = ev.target.result;
        img.className = 'kiage-foto-thumb';
        fotoPreview.appendChild(img);
      };
      reader.readAsDataURL(file);
    });
  });

  startPolling();
})();